import usePluginHandler from '../../../hooks/usePluginHandler';
import { PluginMessageTypes } from '../../../models/constants';
import { callAndResponseToChild, CallForwardTypes } from '../../../models/forward';

const messageHandler = (message) => {
  if (message.type === PluginMessageTypes.CALL_FORWARD) {
    const {
      type, uri, params, callId,
    } = message.payload;
    // gestisco solo call delle tipologie ammesse in CallForwardTypes
    if (!type || !CallForwardTypes.includes(type)) return;
    // effettuo la chiamata e ritorno la risposta al figlio
    callAndResponseToChild(type, uri, params, callId);
  }
};

/**
 * Gestisce l'inoltro di chiamate tra plugins
 */
export default function useCallForward() {
  usePluginHandler(messageHandler);
}
